/* eslint-disable react/prop-types */
import React from 'react';
import DatePicker from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';
import { scrollToTop } from '../../utils/smartutils';

const YearField = ({
  disabled,
  input,
  placeholder,
  minDate,
  maxDate,
  meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <div className="date-field">
      <DatePicker
        disabled={disabled}
        showPopperArrow={false}
        dateFormat="yyyy"
        showYearPicker
        locale={ptBr}
        selected={input.value || null}
        onChange={input.onChange}
        minDate={minDate}
        maxDate={maxDate}
        disabledKeyboardNavigation
        placeholderText={placeholder}
      />
    </div>
    {touched && error && (
      <span className="form__form-group-error">
        {error} {scrollToTop()}
      </span>
    )}
  </div>
);

YearField.defaultProps = {
  disabled: false,
};

export default YearField;
